module.exports = __webpack_public_path__ + "static/media/header.2dd869aa.png";